<template>
  <v-menu bottom dense offset-y>
    <template #activator="{ on, attrs }">
      <v-skeleton-loader
        v-bind="attrs"
        :loading="skeleton"
        :class="$vnode.data.staticClass"
        type="button"
        v-on="on"
      >
        <slot name="activator">
          <BTooltipButton
            :tooltip="tooltip"
            :class-button="classButton"
            :icon="icon"
            :text="text"
            :small="small"
            :disabled="disabled"
            :loading="isLoading"
            depressiconed
            top
          >
            <template #button-inner>
              <slot name="button-inner" />
            </template>
          </BTooltipButton>
        </slot>
      </v-skeleton-loader>
    </template>

    <v-list dense class="pa-0">
      <v-list-item
        v-for="item in list"
        :key="item.id"
        :disabled="item.disabled"
        @click="onSelect(item)"
      >
        <v-list-item-title>
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export default {
  name: 'BMenuMore',
  components: {
    BTooltipButton,
  },
  props: {
    skeleton: Boolean,
    text: String,
    disabled: Boolean,
    small: Boolean,
    tooltip: {
      type: String,
      default: 'Изменить выбранные',
    },
    icon: {
      type: String,
      default: 'mdi-dots-vertical',
    },
    classButton: {
      type: [String, Object, Array],
      default: 'grey lighten-4',
    },
    list: {
      type: Array,
      required: true,
      validator: (prop) => prop.length > 0,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
    onSelect(data) {
      this.$emit(data.id || data.event, data, this.toggleLoading)
      this.$emit('selected', data, this.toggleLoading)
    },
  },
}
</script>
